import withStyles from "@material-ui/styles/withStyles"
import React, { Component } from "react"
import rebase from "../../../config/rebase"

import CustomCardItem from "../../../components/Cards/CustomCardItem"
import Wrapper from "../../../components/Common/Wrapper"
import CustomAlert from "../../../components/CustomAlert"
import Attribution from "../../../components/Grade/Attribution"
import ThreeAsTwo from "../../../components/Steps/ThreeAsTwo"
import { criteriaGradingRules, dbPrefix } from "../../../Constants"
import { getReportFromKAAndReviewers, updateReport } from "../../../rebaseService"
import { isGradeAssignmentAvailable } from "../../../utils"

const styles = theme => ({
  paper: {
    margin: '10px',
    padding: theme.spacing(3),
    textAlign: "left",
    color: theme.palette.text.secondary
  },
  root: {
    flexGrow: 1,
    marginTop: '72px',
  },
  grid: {
    width: 1200,
    marginTop: 40,
    [theme.breakpoints.down("sm")]: {
      width: "calc(100% - 20px)"
    }
  },
  rangeLabel: {
    display: "flex",
    justifyContent: "space-between",
    paddingTop: theme.spacing(2)
  },
  topBar: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: 32
  },
  outlinedButtom: {
    textTransform: "uppercase",
    margin: theme.spacing(1)
  },
  actionButtom: {
    textTransform: "uppercase",
    margin: theme.spacing(1),
    width: 152
  },
  blockCenter: {
    padding: theme.spacing(2),
    textAlign: "center"
  },
  block: {
    padding: theme.spacing(2)
  },
  box: {
    marginBottom: 40,
    height: 65
  },
  inlining: {
    display: "inline-block",
    marginRight: 10
  },
  buttonBar: {
    display: "flex"
  },
  alignRight: {
    display: "flex",
    justifyContent: "flex-end"
  },
  noBorder: {
    borderBottomStyle: "hidden"
  },
  loadingState: {
    opacity: 0.05
  },
  loadingMessage: {
    position: "absolute",
    top: "40%",
    left: "40%"
  }
})

class Papers extends Component {

  state = {
    form: true,
    hasCoi: null,
    accepted: null,
    needsChanges: null,
    accessCode: "",
    coiText: "",
    paper: false,
    users: [],
    loaded: false,
    showDialog: false,
    comment: "",
    grades: {},
    inputError: false,
  }

  async componentDidMount() {
    const { id } = this.props.match.params
    this.setState({ id })
    if (!id) {
      return window.location.replace('/')
    }

    try {
      const paper = await rebase.fetch(dbPrefix + 'papers/' + id, {
        asArray: false
      })

      this.setState({ paper })

      if (paper) {
        for (let index = 0; index < paper.usersId.length; index++) {
          const cpf = paper.usersId[index]
          const user = await rebase.fetch(dbPrefix + 'users/' + cpf, {
            asArray: false
          })
          this.setState({ users: [...this.state.users, user] })
        }

      } else {
        return window.location.replace('/')
      }

    } catch (error) {
      this.setState({ error: "Ocorreu um erro..." })
    } finally {
      this.setState({ loaded: true })
    }
  }

  handleChange = e => {
    this.setState({ [e.target.name]: e.target.value })
  }
  handleGradeInput = e => {
    this.setState({ grades: { ...this.state.grades, [e.target.name]: e.target.value } })
  }

  handleSaveGrade = async () => {
    try {
      this.setState({ inputError: false, loaded: false })
      const { grades, comment, accessCode, id, paper, accepted, needsChanges, observation, hasCoi, coiText } = this.state
      let { knowledgeArea } = this.state.paper
      // Sempre deve ter o código de acesso
      if (!accessCode) {
        return this.setState({ inputError: "Você deve inserir o código de acesso designado" })
      }

      let report = await getReportFromKAAndReviewers(knowledgeArea, accessCode)
      if (report.length === 0) {
        return this.setState({ inputError: "Você não tem permissão para avaliar este trabalho" })
      }
      let target = report.find(r => r.paper === id)
      if (target.status !== 'open') {
        return this.setState({ inputError: "Você já avaliou este trabalho" })
      }

      if (hasCoi === null) {
        return this.setState({ inputError: "Você deve definir se o trabalho possui conflito de interesse" })
      } else {
        if (hasCoi === 'true') {
          if (!coiText) {
            return this.setState({ inputError: "Você deve descrever o conflito de interesse" })
          }
          // Se tem COI, não precisa preencher as notas
          const data = {
            status: 'coi',
            coiText,
            reviewer: accessCode,
            paper: id
          }
          await updateReport(data, knowledgeArea, target.key)
          this.setState({ success: "Conflito de interesse registrado", form: false })
        } else {
          // se não for coi, verifica se foi aceito ou não
          if (accepted === null) {
            return this.setState({ inputError: "Você deve definir se o trabalho foi aceito ou não" })
          }
          // Se aceito, tem que preencher as notas
          if (accepted === 'true') {

            if (needsChanges === null) {
              return this.setState({ inputError: "Você deve definir se o trabalho necessita de alterações" })
            }

            // Verificar dados vazios
            if (!grades) {
              return this.setState({ inputError: "Há nota(s) que ainda não foram atribuídas. Verifique o formulário" })
            }

            if (!comment) {
              return this.setState({ inputError: "Você deve inserir um comentário" })
            }

            // Verificar dados vazios a partir do objeto
            if (Object.values(criteriaGradingRules).length !== Object.values(grades).length) {
              return this.setState({ inputError: "Há nota(s) que ainda não foram atribuídas. Verifique o formulário" })
            }

            // Verificação 1 por 1
            for (let index = 0; index < criteriaGradingRules.length; index++) {
              const element = criteriaGradingRules[index];
              const target = grades[element.name]
              if (!target) {
                return this.setState({ inputError: `Campo ${element.title} vazio. Verifique o formulário` })
              }
              if (isNaN(Number(target)) || target > 10 || target < 0) {
                return this.setState({ inputError: `Campo ${element.title} inválido. Deve ser entre 10 e 0` })
              }
            }

            const data = {
              accepted: true,
              status: 'finished',
              ...grades,
              accessCode,
              comment,
              needsChanges
            }
            await updateReport(data, knowledgeArea, target.key)
            this.setState({ success: "Nota atribuída com sucesso", form: false })
          } else {

            // Se não aceito, tem que preencher a observação
            if (!observation) {
              return this.setState({ inputError: "Você deve descrever a observação caso o trabalho não tenha sido aceito" })
            }
            const data = {
              accepted: false,
              status: 'finished',
              observation,
              accessCode
            }
            await updateReport(data, knowledgeArea, target.key)
            this.setState({ success: "Nota atribuída com sucesso", form: false })

          }
        }
      }
    } catch (error) {
      console.log(error)
      this.setState({ error: "Ocorreu um erro..." })
    } finally {
      this.setState({ loaded: true, showDialog: false })
    }
  }

  render() {
    const { classes } = this.props
    const { paper, users, form } = this.state

    return (
      <Wrapper loaded={this.state.loaded} success={this.state.success} fatalError={this.state.error} currentPath={"/avaliador/papers-para-avaliar"} evaluatorTopbar>
        {
          form &&
          <>
            <ThreeAsTwo
              readOnly
              asEvaluator
              firstAuthor={paper.firstAuthor}
              knowledgeArea={paper.knowledgeArea}
              paperTitle={paper.paperTitle}
              paperFile={paper.paperFile}
              videoLink={paper.videoLink}
              paperURL={paper.paperURL}
              paperURL2={paper.paperURL2}
              abstract={paper.abstract}
              classes={classes}
              users={users}
            />
            {/* se a qtd de reports for >= à qtd de accesscode */}
            {
              isGradeAssignmentAvailable() ?
                <Attribution
                  hasCoi={this.state.hasCoi}
                  coiText={this.state.coiText}
                  accepted={this.state.accepted}
                  grades={this.state.grades}
                  inputError={this.state.inputError}
                  accessCode={this.state.accessCode}
                  comment={this.state.comment}
                  needsChanges={this.state.needsChanges}
                  saveDialog={this.state.showDialog}
                  handleClose={() => this.setState({ showDialog: false })}
                  handleOpen={() => this.setState({ showDialog: true })}
                  handleChange={this.handleChange}
                  agree={e => this.handleSaveGrade(e)}
                  onChange={e => this.handleGradeInput(e)}
                />
                :
                <CustomCardItem>
                  <CustomAlert message="A avaliação não é permitida neste período" />
                </CustomCardItem>
            }
          </>
        }

      </Wrapper>
    )
  }
}
export default withStyles(styles)(Papers)
